import React from 'react';
import { openCookieSettings } from './consentStore';

/** Reopens the cookie choices. Each footer passes its own link class. */
export default function CookieSettingsButton({ className = '', children = 'Cookie settings' }) {
  return (
    <button
      type="button"
      className={`${className} ivori-cookie-settings-link`.trim()}
      onClick={openCookieSettings}
    >
      {children}
    </button>
  );
}
